import React from 'react';
import {Box, Button} from '@mui/material';

export default function ButtonSubmit(props) {
  const {name, onSubmit, isPending, type, disabled, style = {}, fullWidth=false} = props;

  return (
    <Box sx={{position: 'relative', ...style}}>
      <Button
        variant='contained'
        color='primary'
        size='small'
        loading={isPending}
        onClick={onSubmit}
        loadingPosition='start'
        disabled={disabled}
        type={type}
        fullWidth={fullWidth}
      >
        {name}
      </Button>
    </Box>
  );
}
